<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { lang } from "../scripts/stores";
    import { groups_fi, groups_en } from "../scripts/questions";
    import Circle from "./Circle.svelte";
    import ChartLabels from "./ChartLabels.svelte";

    export let totalScores = [];

    const dispatch = createEventDispatcher();

    let groups = $lang === "fi" ? groups_fi : groups_en;
    let chartType = "turn";

    $: if($lang) groups = $lang === "fi" ? groups_fi : groups_en;
    
    function selectCategory(index) {
        dispatch("select", { index });
    }

    onMount(() => {
        window.scrollTo(0, 0);
    })

</script>

<style>
    .chart-container {
        width: 95%;
        max-width: 960px;
        margin: 0 auto;
        padding-top: 1rem;
        border-radius: 6px;
        /* border: 1px solid gray; */
    }
    .circle-container {
        display: flex;
        justify-content: space-between;
        justify-items: center;
        flex-wrap: wrap;
        margin-top: 2.5rem;
    }
    .chart-title {
        margin-top: 2.5rem;
        text-align: center;
    }
</style>

<div class="chart-container">
    <h2 class="chart-title">
        { $lang === "fi" ? "Kokonaispisteet" : "Overall points" }
    </h2>

    <div class="circle-container">    
        {#each totalScores as totalScore, i}
            <Circle title={ groups[i] } value={ (totalScore / 100) } { chartType } on:click={ () => selectCategory(i) } />
        {/each}
    </div>
    
    <ChartLabels { chartType } />
</div>


